const initState = {
  autoShipError: null,
  autoShipMessage: null,
  autoShipPopUp: false,
  autoShipErrorPopup: false,
  autoShipCompany: null, //This is the clinic data ({id, data, pureTier, naturalTier})
  clinicLoaded: false, //Once a clinic is loaded
  autoShipOrderID: null, //This is the id of the autoship order
  loadingAutoShipOrder: false, //This will show the order form if true else shows the clinic overview
  programElevate: false, //This handles if the clinic is going to elevate or not
  autoshipSettings: null, //This has all of the settins, starting month etc
  months: null, //This is the month data to load in the information
  autoshipSettingsLoaded: false, // This will be used to make sure the base settings are loaded
  items: null, //This will be where all of the items will be stored
  cbItems: [],
  fItems: [],
  tItems: [],
  bItems: [],
  cbmonths: [],
  tmonths: [],
  fmonths: [],
  bmonths: [],
  cbMonthItems: [],
  tMonthItems: [],
  fMonthItems: [],
  bItemsMonth: [],
  monthTotals: [],
  monthlyCommitment: 0,
  minAutoshipCommitment: 0,
  minToKeep: 0,
  leftToFillAutoship: 0,
  lefttoEarnAutoshipPromo: 0,
  totalOrder: 0, // this is the total tally of the order
  editMonth: 0, // This is the month that will be editing the list DEFAULT IS FIRST MONTH
  editBrand: 'Clear + Brilliant', //This is the brand that will be brand that we are editing
  loadFreshAutoShipOrder: true, //This is used to check if we are loading a fresh order or data from saved one
  order: [], //This is what we will use to to store the order data
  pricingTier: null, //We will use this to set the pricing tier so we can use the correct data
  autoShipTiers: null, // WE will store all of the autoship tiers here
  savingOrder: false, //This is used for the icon and the user experince
  promoTips: null, //This is the number of tips that they could get
  autoShipCreatorUserID: null, //this is the user that created the autoship order
  orderName: '',
  orderChanged: false, //We are going to use this to save the order for autosave
  selectedShippingID: 0, //This is going to be used for multiple ship to ids
  orderShippingID: '', //This is going to be used for multpile shippind IDs it will store the ID
  multipleIDs: false, //We will use this a a true or false to figure out if order is multple IDS
  eliteCompany: false, // We will use this to keep track if that company is a elite company therefor load elite program
};

const autoShipReducer = (state = initState, action) => {
  switch (action.type) {
    case 'CLOSE_AUTOSHIP_POPUPS':
      return {
        ...state,
        autoShipPopUp: false,
        autoShipErrorPopup: false,
        autoShipError: null,
        autoShipMessage: null,
      };

    case 'CLEAN_AUTOSHIP_ORDER':
      return {
        ...state,
        clinicLoaded: false, //Once a clinic is loaded
        autoShipOrderID: null, //This is the id of the autoship order
        loadingAutoShipOrder: false, //This will show the order form if true else shows the clinic overview
        programElevate: false, //This handles if the clinic is going to elevate or not
        autoshipSettings: null, //This has all of the settins, starting month etc
        months: null, //This is the month data to load in the information
        autoshipSettingsLoaded: false, // This will be used to make sure the base settings are loaded
        items: null, //This will be where all of the items will be stored
        cbItems: [],
        fItems: [],
        tItems: [],
        bItems: [],
        cbmonths: [],
        tmonths: [],
        fmonths: [],
        cbMonthItems: [],
        tMonthItems: [],
        fMonthItems: [],
        bItemsMonth: [],
        monthTotals: [],
        monthlyCommitment: 0,
        minAutoshipCommitment: 0,
        minToKeep: 0,
        leftToFillAutoship: 0,
        lefttoEarnAutoshipPromo: 0,
        totalOrder: 0, // this is the total tally of the order
        editMonth: 0, // This is the month that will be editing the list DEFAULT IS FIRST MONTH
        editBrand: 'Clear + Brilliant', //This is the brand that will be brand that we are editing
        loadFreshAutoShipOrder: true, //This is used to check if we are loading a fresh order or data from saved one
        order: [], //This is what we will use to to store the order data
        pricingTier: null, //We will use this to set the pricing tier so we can use the correct data
        autoShipTiers: null, // WE will store all of the autoship tiers here
        savingOrder: false, //This is used for the icon and the user experince
        promoTips: null,
        orderName: '',
        orderShippingID: '',
        multipleIDs: false,
        selectedShippingID: 0, //This is going to be used for multiple ship to ids
        eliteCompany: false,
      };
    case 'AUTOSHIP_COMPANY_FOUND':
      //console.log(action.clinic);
      //console.log('loading in the pricing tier from the comany found', action.clinic.pureTier.id);
      //console.log('loading in with found company');
      //console.log('this is my eliteCompany', action.clinic.data.eliteProgram);
      return {
        ...state,
        autoShipCompany: action.clinic,
        clinicLoaded: true,
        pricingTier: action.clinic.pureTier.tierName !== 'Bronze' ? action.clinic.pureTier.id : '3IaLvKVToLsbcC8neru7',
        programElevate: action.clinic.pureTier.tierName !== 'Silver' ? false : true,
        loadingAutoShipOrder: false,
        monthlyCommitment:
          action.clinic.pureTier.tierName === action.clinic.naturalTier.tierElevate
            ? action.clinic.naturalTier.tierName !== 'Silver'
              ? Math.round(action.clinic.naturalTier.tierMaintainMin / 6)
              : Math.round(action.clinic.pureTier.tierElevateMin / 6)
            : action.clinic.pureTier.tierName !== 'Silver'
            ? Math.round(action.clinic.pureTier.tierMaintainMin / 6)
            : Math.round(action.clinic.pureTier.tierElevateMin / 6),
        minAutoshipCommitment: action.clinic.pureTier.tierName === action.clinic.naturalTier.tierElevate ? (action.clinic.naturalTier.tierName !== 'Silver' ? action.clinic.naturalTier.tierMaintainMin : action.clinic.naturalTier.tierElevateMin) : action.clinic.pureTier.tierName !== 'Silver' ? action.clinic.pureTier.tierMaintainMin : action.clinic.pureTier.tierElevateMin,
        minToKeep: action.clinic.pureTier.tierName === action.clinic.naturalTier.tierElevate ? (action.clinic.naturalTier.tierName !== 'Silver' ? action.clinic.naturalTier.tierMaintainTrueUp : action.clinic.naturalTier.tierElevateTrueup) : action.clinic.pureTier.tierName !== 'Silver' ? action.clinic.pureTier.tierMaintainTrueUp : action.clinic.pureTier.tierElevateTrueup,
        leftToFillAutoship: action.clinic.pureTier.tierName === action.clinic.naturalTier.tierElevate ? (action.clinic.naturalTier.tierName !== 'Silver' ? action.clinic.naturalTier.tierMaintainMin : action.clinic.naturalTier.tierElevateMin) : action.clinic.pureTier.tierName !== 'Silver' ? action.clinic.pureTier.tierMaintainMin : action.clinic.pureTier.tierElevateMin,
        lefttoEarnAutoshipPromo:
          action.clinic.pureTier.tierName === action.clinic.naturalTier.tierElevate ? (action.clinic.naturalTier.tierName !== 'Silver' ? action.clinic.naturalTier.tierMaintainTrueUp : action.clinic.naturalTier.tierElevateTrueup) : action.clinic.pureTier.tierName !== 'Silver' ? action.clinic.pureTier.tierMaintainTrueUp : action.clinic.pureTier.tierElevateTrueup,
        promoTips: action.clinic.pureTier.tierName === action.clinic.naturalTier.tierElevate ? (action.clinic.naturalTier.tierName !== 'Silver' ? action.clinic.naturalTier.promoBonus : action.clinic.naturalTier.elevatedPromoBonus) : action.clinic.pureTier.tierName !== 'Silver' ? action.clinic.pureTier.promoBonus : action.clinic.pureTier.elevatedPromoBonus,
        orderShippingID: action.clinic.data.shippingIDs ? action.clinic.data.shippingIDs[0] : '',
        eliteCompany: action.clinic.data.eliteProgram ? action.clinic.data.eliteProgram : false,
      };
    case 'AUTOSHIP_COMPANY_COULD_NOT_BE_FOUND':
      return {
        ...state,
        autoShipError: 'We are sorry that clinics information could not be found',
        autoShipErrorPopup: true,
      };
    case 'ERROR_FINDING_AUTOSHIP_COMPANY':
      return {
        ...state,
        autoShipError: action.err.message,
        autoShipErrorPopup: true,
      };
    case 'ERROR_CREATING_AUTOSHIP_ORDER':
      return {
        ...state,
        autoShipError: action.err.message,
        autoShipErrorPopup: true,
      };
    case 'AUTOSHIP_ORDER_CREATED':
      return {
        ...state,
        autoShipOrderID: action.resp.id,
        loadingAutoShipOrder: true,
      };

    case 'ELVATE_AUTOSHIP_ORDER':
      //We are going to need to cycle through the order and update all of the prices.
      const elvateOrder = state.order;
      const elvatedMonths = state.monthTotals;

      if (state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName) {
        //console.log('this is my new order');

        return {
          ...state,
          monthlyCommitment:
            state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
              ? state.programElevate
                ? Math.round(state.autoShipCompany.naturalTier.tierMaintainMin / (state.eliteCompany ? 12 : 6))
                : Math.round(state.autoShipCompany.naturalTier.tierElevateMin / (state.eliteCompany ? 12 : 6))
              : state.programElevate
              ? Math.round(state.autoShipCompany.pureTier.tierMaintainMin / (state.eliteCompany ? 12 : 6))
              : Math.round(state.autoShipCompany.pureTier.tierElevateMin / (state.eliteCompany ? 12 : 6)),
          minAutoshipCommitment: state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName ? (state.programElevate ? state.autoShipCompany.naturalTier.tierMaintainMin : state.autoShipCompany.naturalTier.tierElevateMin) : state.programElevate ? state.autoShipCompany.pureTier.tierMaintainMin : state.autoShipCompany.pureTier.tierElevateMin,
          minToKeep: state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName ? (state.programElevate ? state.autoShipCompany.naturalTier.tierMaintainTrueUp : state.autoShipCompany.naturalTier.tierElevateTrueup) : state.programElevate ? state.autoShipCompany.pureTier.tierMaintainTrueUp : state.autoShipCompany.pureTier.tierElevateTrueup,
          leftToFillAutoship: state.eliteCompany
            ? state.programElevate
              ? state.autoShipCompany.naturalTier.tierMaintainMin
              : state.autoShipCompany.naturalTier.tierElevateMin
            : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
            ? state.programElevate
              ? state.autoShipCompany.naturalTier.tierMaintainMin
              : state.autoShipCompany.naturalTier.tierElevateMin
            : state.programElevate
            ? state.autoShipCompany.pureTier.tierMaintainMin
            : state.autoShipCompany.pureTier.tierElevateMin,
          lefttoEarnAutoshipPromo: state.eliteCompany
            ? state.programElevate
              ? state.autoShipCompany.naturalTier.tierMaintainMin
              : state.autoShipCompany.naturalTier.tierElevateMin
            : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
            ? state.programElevate
              ? state.autoShipCompany.naturalTier.tierMaintainTrueUp
              : state.autoShipCompany.naturalTier.tierElevateTrueup
            : state.programElevate
            ? state.autoShipCompany.pureTier.tierMaintainTrueUp
            : state.autoShipCompany.pureTier.tierElevateTrueup,
          programElevate: state.programElevate ? false : true,
          pricingTier: state.autoShipCompany.pureTier.tierName !== 'Bronze' ? state.autoShipCompany.pureTier.id : '3IaLvKVToLsbcC8neru7', //Silver ID
          promoTips: state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName ? (state.programElevate ? state.autoShipCompany.naturalTier.promoBonus : state.autoShipCompany.naturalTier.elevatedPromoBonus) : state.programElevate ? state.autoShipCompany.pureTier.promoBonus : state.autoShipCompany.pureTier.elevatedPromoBonus,
          orderChanged: true,
        };
      } else {
        if (state.multipleIDs) {
          //we are going to need to go throught the shipping IDS
          Object.keys(state.order).map((sID, k) => {
            Object.keys(state.order[sID].months).map((o, i) => {
              //Go through clear + Brilliant
              Object.keys(state.order[sID].months[o]['Clear + Brilliant']).map((ci, k) => {
                let newPrice = getItemPricing({ singleItem: state.order[sID].months[o]['Clear + Brilliant'][ci].item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate ? false : true });
                elvateOrder[sID].months[i]['Clear + Brilliant'][k].price = newPrice * elvateOrder[sID].months[i]['Clear + Brilliant'][k].quantiy;
                let monthTotal = getTotalNumberofSpend({ orderGroup: elvateOrder[sID].months[i]['Clear + Brilliant'] });
                return (elvateOrder[sID].months[i].total = { ...elvateOrder[sID].months[i].total, 'Clear + Brilliant': monthTotal });
              });
              //Go through Thermage
              Object.keys(state.order[sID].months[o]['Thermage']).map((ti, k) => {
                let newPrice = getItemPricing({ singleItem: state.order[sID].months[o]['Thermage'][ti].item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate ? false : true });
                elvateOrder[sID].months[i]['Thermage'][k].price = newPrice * elvateOrder[sID].months[i]['Thermage'][k].quantiy;

                let monthTotal = getTotalNumberofSpend({ orderGroup: elvateOrder[sID].months[i]['Thermage'] });
                return (elvateOrder[sID].months[i].total = { ...elvateOrder[sID].months[i].total, Thermage: monthTotal });
              });
              //Go through Fraxel
              Object.keys(state.order[sID].months[o]['Fraxel']).map((fi, k) => {
                let newPrice = getItemPricing({ singleItem: state.order[sID].months[o]['Fraxel'][fi].item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate ? false : true });
                elvateOrder[sID].months[i]['Fraxel'][k].price = newPrice * elvateOrder[sID].months[i]['Fraxel'][k].quantiy;

                let monthTotal = getTotalNumberofSpend({ orderGroup: elvateOrder[sID].months[i]['Fraxel'] });
                return (elvateOrder[sID].months[i].total = { ...elvateOrder[sID].months[i].total, Fraxel: monthTotal });
              });

              let monthTotalA = getMonthTotal({ orderGroup: elvateOrder[sID].months[i] });
              if (elvatedMonths[sID][i]) {
                elvatedMonths[sID][i].total = monthTotalA;
              } else {
                elvatedMonths[sID][i + 6].total = monthTotalA;
              }

              return null;
            });
            return null;
          });
        } else {
          console.log('this is my state.order.months', state.order);

          state.order.months.map((o, i) => {
            //Go through clear + Brilliant
            //console.log('this is my o', o);
            if (Array.isArray(o['Clear + Brilliant'])) {
              o['Clear + Brilliant'].map((ci, k) => {
                let newPrice = getItemPricing({ singleItem: ci.item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate ? false : true });
                elvateOrder.months[i]['Clear + Brilliant'][k].price = newPrice * elvateOrder.months[i]['Clear + Brilliant'][k].quantiy;

                let monthTotal = getTotalNumberofSpend({ orderGroup: elvateOrder.months[i]['Clear + Brilliant'] });
                return (elvateOrder.months[i].total = { ...elvateOrder.months[i].total, 'Clear + Brilliant': monthTotal });
              });
            } else {
              Object.keys(o['Clear + Brilliant']).map((ci, k) => {
                let newPrice = getItemPricing({ singleItem: o['Clear + Brilliant'][ci].item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate ? false : true });
                elvateOrder.months[i]['Clear + Brilliant'][k].price = newPrice * elvateOrder.months[i]['Clear + Brilliant'][k].quantiy;

                let monthTotal = getTotalNumberofSpend({ orderGroup: elvateOrder.months[i]['Clear + Brilliant'] });
                return (elvateOrder.months[i].total = { ...elvateOrder.months[i].total, 'Clear + Brilliant': monthTotal });
              });
            }

            //Go through Thermage
            if (Array.isArray(o['Thermage'])) {
              o['Thermage'].map((ti, k) => {
                let newPrice = getItemPricing({ singleItem: ti.item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate ? false : true });
                elvateOrder.months[i]['Thermage'][k].price = newPrice * elvateOrder.months[i]['Thermage'][k].quantiy;

                let monthTotal = getTotalNumberofSpend({ orderGroup: elvateOrder.months[i]['Thermage'] });
                return (elvateOrder.months[i].total = { ...elvateOrder.months[i].total, Thermage: monthTotal });
              });
            } else {
              Object.keys(o['Thermage']).map((ti, k) => {
                let newPrice = getItemPricing({ singleItem: o['Thermage'][ti].item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate ? false : true });
                elvateOrder.months[i]['Thermage'][k].price = newPrice * elvateOrder.months[i]['Thermage'][k].quantiy;

                let monthTotal = getTotalNumberofSpend({ orderGroup: elvateOrder.months[i]['Thermage'] });
                return (elvateOrder.months[i].total = { ...elvateOrder.months[i].total, Thermage: monthTotal });
              });
            }

            //Go through Fraxel
            if (Array.isArray(o['Fraxel'])) {
              o['Fraxel'].map((fi, k) => {
                let newPrice = getItemPricing({ singleItem: fi.item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate ? false : true });
                elvateOrder.months[i]['Fraxel'][k].price = newPrice * elvateOrder.months[i]['Fraxel'][k].quantiy;

                let monthTotal = getTotalNumberofSpend({ orderGroup: elvateOrder.months[i]['Fraxel'] });
                return (elvateOrder.months[i].total = { ...elvateOrder.months[i].total, Fraxel: monthTotal });
              });
            } else {
              Object.keys(o['Fraxel']).map((fi, k) => {
                let newPrice = getItemPricing({ singleItem: o['Fraxel'][fi].item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate ? false : true });
                elvateOrder.months[i]['Fraxel'][k].price = newPrice * elvateOrder.months[i]['Fraxel'][k].quantiy;

                let monthTotal = getTotalNumberofSpend({ orderGroup: elvateOrder.months[i]['Fraxel'] });
                return (elvateOrder.months[i].total = { ...elvateOrder.months[i].total, Fraxel: monthTotal });
              });
            }

            let monthTotalA = getMonthTotal({ orderGroup: elvateOrder.months[i] });
            elvatedMonths[i].total = monthTotalA;

            return null;
          });
        }

        let elvatedTotal = totalAmount({ orderGroup: elvatedMonths, multipleIDs: state.multipleIDs });
        //console.log('this is my new elveated order', elvateOrder);
        let companyTier = state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName ? (state.programElevate ? state.autoShipCompany.naturalTier.tierName : state.autoShipCompany.naturalTier.tierElevate) : state.programElevate ? state.autoShipCompany.pureTier.tierName : state.autoShipCompany.pureTier.tierElevate;
        let elvatedTier = state.autoShipTiers.filter((t) => t.data.tierName === companyTier);

        //console.log('this is my elevatedTier', elvatedTier);
        //console.log('these are my autoshipTiers', state.autoShipTiers);
        //console.log('this is my company Tier', companyTier[0]);

        return {
          ...state,
          monthlyCommitment:
            state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
              ? state.programElevate
                ? Math.round(state.autoShipCompany.naturalTier.tierMaintainMin / (state.eliteCompany ? 12 : 6))
                : Math.round(state.autoShipCompany.naturalTier.tierElevateMin / (state.eliteCompany ? 12 : 6))
              : state.programElevate
              ? Math.round(state.autoShipCompany.pureTier.tierMaintainMin / (state.eliteCompany ? 12 : 6))
              : Math.round(state.autoShipCompany.pureTier.tierElevateMin / (state.eliteCompany ? 12 : 6)),
          minAutoshipCommitment: state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName ? (state.programElevate ? state.autoShipCompany.naturalTier.tierMaintainMin : state.autoShipCompany.naturalTier.tierElevateMin) : state.programElevate ? state.autoShipCompany.pureTier.tierMaintainMin : state.autoShipCompany.pureTier.tierElevateMin,
          minToKeep: state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName ? (state.programElevate ? state.autoShipCompany.naturalTier.tierMaintainTrueUp : state.autoShipCompany.naturalTier.tierElevateTrueup) : state.programElevate ? state.autoShipCompany.pureTier.tierMaintainTrueUp : state.autoShipCompany.pureTier.tierElevateTrueup,
          leftToFillAutoship: state.eliteCompany
            ? state.programElevate
              ? state.autoShipCompany.naturalTier.tierMaintainMin
              : state.autoShipCompany.naturalTier.tierElevateMin
            : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
            ? state.programElevate
              ? state.autoShipCompany.naturalTier.tierMaintainMin
              : state.autoShipCompany.naturalTier.tierElevateMin
            : state.programElevate
            ? state.autoShipCompany.pureTier.tierMaintainMin
            : state.autoShipCompany.pureTier.tierElevateMin,
          lefttoEarnAutoshipPromo: state.eliteCompany
            ? state.programElevate
              ? state.autoShipCompany.naturalTier.tierMaintainMin
              : state.autoShipCompany.naturalTier.tierElevateMin
            : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
            ? state.programElevate
              ? state.autoShipCompany.naturalTier.tierMaintainTrueUp
              : state.autoShipCompany.naturalTier.tierElevateTrueup
            : state.programElevate
            ? state.autoShipCompany.pureTier.tierMaintainTrueUp
            : state.autoShipCompany.pureTier.tierElevateTrueup,
          programElevate: state.programElevate ? false : true,
          order: elvateOrder,
          monthTotals: { ...elvatedMonths },
          totalOrder: elvatedTotal,
          pricingTier: elvatedTier[0].id,
          promoTips: state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName ? (state.programElevate ? state.autoShipCompany.naturalTier.promoBonus : state.autoShipCompany.naturalTier.elevatedPromoBonus) : state.programElevate ? state.autoShipCompany.pureTier.promoBonus : state.autoShipCompany.pureTier.elevatedPromoBonus,
          orderChanged: true,
        };
      }

    case 'AUTOSHIP_SETTINGS_LOADED':
      //We are going to want to do some things before we get things going
      //Figure out based on the settings we only want six months
      //We might want to load in the all of the items and have them sorted by brand
      //console.log('we are building the variables');
      //Get the starting month
      const settings = action.resp.settings;
      const allMonths = action.resp.months;
      const allItems = action.resp.items;
      const startMonth = settings.startMonth;

      //Set all of the default values
      const cbItems = [];
      const tItems = [];
      const fItems = [];
      const bItems = [];
      //const cbItemsSorted = [];

      const cbMonths = [];
      const tMonths = [];
      const fMonths = [];
      const bMonths = [];
      const cbItemsMonth = { months: [], bonus: [] };
      const tItemsMonth = { months: [], bonus: [] };
      const fItemsMonth = { months: [], bonus: [] };
      const bItemsMonth = { months: [] };

      //Create the month block
      const firstMonth = startMonth;
      const lastMonth = firstMonth + (state.autoShipCompany.data.eliteProgram ? 11 : 5);
      const monthOrder = [];
      const monthTotals = [];
      const multiMonthTotals = {}; //This will be used to create a with multi ship to ids

      //Create the total order setup
      const order = {};

      order.months = [];

      //WE are going to sort the brands into thier own item lists.
      allItems.map((item) => {
        if (item.data.brand === 'Clear + Brilliant') {
          cbItems.push(item);
        }

        if (item.data.brand === 'Fraxel') {
          fItems.push(item);
        }

        if (item.data.brand === 'Thermage') {
          tItems.push(item);
        }
        bItems.push(item);
        return true;
      });

      //Lets sort the items so that they are in order
      const cbItemsSorted = cbItems.sort((a, b) => a.data.listOrder - b.data.listOrder);
      const tItemsSorted = tItems.sort((a, b) => a.data.listOrder - b.data.listOrder);
      const fItemsSorted = fItems.sort((a, b) => a.data.listOrder - b.data.listOrder);
      //console.log('this is my items ', tItemsSorted);

      //First thing is to find the month order
      if (lastMonth < 12) {
        //lets do the standard here
        for (let i = firstMonth; i <= lastMonth; i++) {
          monthOrder.push(allMonths[i]);
          monthTotals.push({ month: allMonths[i], total: 0 });
        }
      } else {
        const extraMonths = lastMonth - 12;
        //Go through the first set of months
        for (let i = firstMonth; i < 12; i++) {
          monthOrder.push(allMonths[i]);
          monthTotals.push({ month: allMonths[i], total: 0 });
        }
        //Then we start off at the year and go through it again
        for (let i = 0; i <= extraMonths; i++) {
          monthOrder.push(allMonths[i]);
          monthTotals.push({ month: allMonths[i], total: 0 });
        }
      }

      //Now we will create all of your item stuff
      monthOrder.map((m, mi) => {
        cbMonths.push({ ...m, brand: 'cbmonths' });
        tMonths.push({ ...m, brand: 'tmonths' });
        fMonths.push({ ...m, brand: 'fmonths' });
        bMonths.push({ ...m, brand: 'bmonths' });

        //This will create the array that we will use to store data in
        order.months.push({ ...m, 'Clear + Brilliant': {}, Thermage: {}, Fraxel: {}, Bonus: {} });

        //Create the base for the items
        cbItemsMonth.months.push({ month: m, amount: 2, items: [] });
        tItemsMonth.months.push({ month: m, amount: 3, items: [] });
        fItemsMonth.months.push({ month: m, amount: 3, items: [] });
        bItemsMonth.months.push({ month: m, amount: 3, items: [] });

        tItemsSorted.map((i) => {
          bItemsMonth.months[mi].items.push({ ...i });
          return tItemsMonth.months[mi].items.push({ ...i });
        });

        fItemsSorted.map((i) => {
          bItemsMonth.months[mi].items.push({ ...i });
          return fItemsMonth.months[mi].items.push({ ...i });
        });

        cbItemsSorted.map((i) => {
          //Just add the items to that month
          bItemsMonth.months[mi].items.push({ ...i });
          return cbItemsMonth.months[mi].items.push({ ...i });
        });

        return null;
      });

      //Adding the bonus section
      order.bonus = { 'Clear + Brilliant': [], Thermage: [], Fraxel: [] };

      cbItemsMonth.bonus.push({ month: 'bonusTips', amount: 2, items: [] });
      tItemsMonth.bonus.push({ month: 'bonusTips', amount: 3, items: [] });
      fItemsMonth.bonus.push({ month: 'bonusTips', amount: 3, items: [] });

      cbItemsSorted.map((i) => {
        //Just add the items to that month
        return cbItemsMonth.bonus[0].items.push({ ...i });
      });

      tItemsSorted.map((i) => {
        return tItemsMonth.bonus[0].items.push({ ...i });
      });

      fItemsSorted.map((i) => {
        return fItemsMonth.bonus[0].items.push({ ...i });
      });

      //This is the code for the multi ship to ids
      const idOrder = {};
      if (state.autoShipCompany.data.shippingIDs) {
        if (Array.isArray(state.autoShipCompany.data.shippingIDs)) {
          if (state.autoShipCompany.data.shippingIDs.length > 1) {
            state.autoShipCompany.data.shippingIDs.map((sID) => {
              idOrder[sID] = {};
              idOrder[sID].months = {};

              monthOrder.map((m, mi) => {
                return (idOrder[sID].months[mi] = { ...m, 'Clear + Brilliant': {}, Thermage: {}, Fraxel: {}, Bonus: {} });
              });

              idOrder[sID].bonus = { 'Clear + Brilliant': [], Thermage: [], Fraxel: [] };

              multiMonthTotals[sID] = {};

              if (lastMonth < 12) {
                //lets do the standard here
                for (let i = firstMonth; i <= lastMonth; i++) {
                  multiMonthTotals[sID][i] = { month: allMonths[i], total: 0 };
                }
              } else {
                const extraMonths = lastMonth - 12;
                //Go through the first set of months
                for (let i = firstMonth; i < 12; i++) {
                  multiMonthTotals[sID][i] = { month: allMonths[i], total: 0 };
                }
                //Then we start off at the year and go through it again
                for (let i = 0; i <= extraMonths; i++) {
                  multiMonthTotals[sID][i] = { month: allMonths[i], total: 0 };
                }
              }

              return true;
            });
          }
        }
      }
      //console.log('this is my autioship Company', state.autoShipCompany);
      return {
        ...state,
        autoshipSettings: settings,
        months: monthOrder,
        autoshipSettingsLoaded: true,
        items: action.resp.items,
        cbmonths: cbMonths,
        tmonths: tMonths,
        fmonths: fMonths,
        cbMonthItems: cbItemsMonth,
        tMonthItems: tItemsMonth,
        fMonthItems: fItemsMonth,
        bItemsMonth: bItemsMonth,
        monthTotals: Object.keys(idOrder).length > 0 ? multiMonthTotals : monthTotals,
        cbItems: cbItems,
        tItems: tItems,
        fItems: fItems,
        bItems: bItems,
        eliteCompany: state.autoShipCompany.data.eliteProgram,
        orderShippingID: state.autoShipCompany.data.shippingIDs ? state.autoShipCompany.data.shippingIDs[0] : '',
        order: Object.keys(idOrder).length > 0 ? { ...idOrder } : { ...order }, //If it has multiple IDS use the other order settings
        multipleIDs: Object.keys(idOrder).length > 0 ? true : false,
        autoShipTiers: action.resp.tiers,
        totalOrder: 0,
        programElevate: state.autoShipCompany.pureTier.tierName !== 'Silver' ? false : true,
        pricingTier: state.autoShipCompany
          ? state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
            ? state.autoShipCompany.pureTier.tierName !== 'Silver'
              ? state.autoShipCompany.pureTier.tierName !== 'Bronze'
                ? state.autoShipCompany.pureTier.id
                : '3IaLvKVToLsbcC8neru7' //Silver ID
              : 'hfgJtLRuei3Ac42Gu1tj' //Gold ID
            : state.autoShipCompany.naturalTier.tierName !== 'Silver' //I will need to grab gold if silver
            ? state.autoShipCompany.naturalTier.id !== 'Bronze'
              ? state.autoShipCompany.naturalTier.id
              : '3IaLvKVToLsbcC8neru7' //Silver ID
            : 'hfgJtLRuei3Ac42Gu1tj' //Gold ID
          : '',
        monthlyCommitment: state.autoShipCompany.data.eliteProgram
          ? state.autoShipCompany.naturalTier.tierMaintainMin / 12
          : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
          ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
            ? Math.round(state.autoShipCompany.naturalTier.tierMaintainMin / 6)
            : Math.round(state.autoShipCompany.pureTier.tierElevateMin / 6)
          : state.autoShipCompany.pureTier.tierName !== 'Silver'
          ? Math.round(state.autoShipCompany.pureTier.tierMaintainMin / 6)
          : Math.round(state.autoShipCompany.pureTier.tierElevateMin / 6),
        minAutoshipCommitment:
          state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
            ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
              ? state.autoShipCompany.naturalTier.tierMaintainMin
              : state.autoShipCompany.naturalTier.tierElevateMin
            : state.autoShipCompany.pureTier.tierName !== 'Silver'
            ? state.autoShipCompany.pureTier.tierMaintainMin
            : state.autoShipCompany.pureTier.tierElevateMin,
        minToKeep:
          state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
            ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
              ? state.autoShipCompany.naturalTier.tierMaintainTrueUp
              : state.autoShipCompany.naturalTier.tierElevateTrueup
            : state.autoShipCompany.pureTier.tierName !== 'Silver'
            ? state.autoShipCompany.pureTier.tierMaintainTrueUp
            : state.autoShipCompany.pureTier.tierElevateTrueup,
        leftToFillAutoship: state.autoShipCompany.data.eliteProgram
          ? state.autoShipCompany.naturalTier.tierMaintainMin
          : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
          ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
            ? state.autoShipCompany.naturalTier.tierMaintainMin
            : state.autoShipCompany.naturalTier.tierElevateMin
          : state.autoShipCompany.pureTier.tierName !== 'Silver'
          ? state.autoShipCompany.pureTier.tierMaintainMin
          : state.autoShipCompany.pureTier.tierElevateMin,
        lefttoEarnAutoshipPromo: state.autoShipCompany.data.eliteProgram
          ? state.autoShipCompany.naturalTier.tierMaintainMin
          : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
          ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
            ? state.autoShipCompany.naturalTier.tierMaintainTrueUp
            : state.autoShipCompany.naturalTier.tierElevateTrueup
          : state.autoShipCompany.pureTier.tierName !== 'Silver'
          ? state.autoShipCompany.pureTier.tierMaintainTrueUp
          : state.autoShipCompany.pureTier.tierElevateTrueup,
      };
    case 'AUTOSHIP_SETTINGS_LIGHT_LOADED':
      //We are going to want to do some things before we get things going
      //Figure out based on the settings we only want six months
      //We might want to load in the all of the items and have them sorted by brand
      const lightItems = action.resp.items;

      //Set all of the default values
      const cbLightItems = [];
      const tLightItems = [];
      const fLightItems = [];
      const bLightItems = [];

      lightItems.map((item) => {
        if (item.data.brand === 'Thermage') {
          tLightItems.push(item);
        }

        if (item.data.brand === 'Fraxel') {
          fLightItems.push(item);
        }

        if (item.data.brand === 'Clear + Brilliant') {
          cbLightItems.push(item);
        }

        return true;
      });

      tLightItems.map((i) => {
        return bLightItems.push(i);
      });

      fLightItems.map((i) => {
        return bLightItems.push(i);
      });

      cbLightItems.map((i) => {
        return bLightItems.push(i);
      });

      return {
        ...state,
        autoshipSettingsLoaded: true,
        items: action.resp.items,
        autoShipTiers: action.resp.tiers,
        //pricingTier: state.autoShipCompany.pureTier.id,
        cbItems: cbLightItems,
        tItems: tLightItems,
        fItems: fLightItems,
        bItems: bLightItems,
      };

    case 'ERROR_NO_MONTHS_FOUND':
      return {
        ...state,
        autoShipError: 'Sorry, there seems to be no month data loaded',
        autoShipErrorPopup: true,
      };
    case 'ERROR_GETTING_MONTHS':
      return {
        ...state,
        autoShipError: action.err.message,
        autoShipErrorPopup: true,
      };
    case 'AUTOSHIP_NO_ITEMS':
      return {
        ...state,
        autoShipError: 'Sorry, there seems to be no items loaded',
        autoShipErrorPopup: true,
      };
    case 'SELECTING_MONTHING_TO_EDIT':
      return {
        ...state,
        editMonth: action.month,
      };
    case 'SELECTING_BRAND_TO_EDIT':
      return {
        ...state,
        editBrand: action.brand,
      };
    case 'ADD_ITEM_TO_ORDER':
      const updatedOrder = { ...state.order };

      const currentMonthTotal = state.monthTotals;

      const newItem = action.resp;

      const oldOrder = newItem.month !== 'bonus' ? (state.multipleIDs ? updatedOrder[state.orderShippingID].months[newItem.month][newItem.brand][newItem.row] : updatedOrder.months[newItem.month][newItem.brand][newItem.row]) : '';

      if (newItem.month !== 'bonus') {
        let itemPricing = state.items.filter((item) => item.data.sku === newItem.item);
        let newPrice = getItemPricing({ singleItem: newItem.item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate });
        //console.log('this is my newItem Brand', newItem.brand);
        //console.log('these are my tiers>>>>>>> ', state.autoShipTiers);
        //console.log('this is my newPrice>>> ', newPrice);

        if (state.multipleIDs) {
          updatedOrder[state.orderShippingID].months[newItem.month][newItem.brand][newItem.row] = { item: newItem.item, quantiy: itemPricing.length > 0 ? 1 : 0, data: itemPricing.length > 0 ? itemPricing[0].data : 0, price: newItem.brand === 'Bonus' ? 0 : newPrice };
        } else {
          updatedOrder.months[newItem.month][newItem.brand][newItem.row] = { item: newItem.item, quantiy: itemPricing.length > 0 ? 1 : 0, data: itemPricing.length > 0 ? itemPricing[0].data : 0, price: newItem.brand === 'Bonus' ? 0 : newPrice };
        }

        //Calculate the total number of items
        let updatedItemNumber = getTotalNumberofItems({ orderGroup: state.multipleIDs ? updatedOrder[state.orderShippingID].months[newItem.month][newItem.brand] : updatedOrder.months[newItem.month][newItem.brand] });

        if (state.multipleIDs) {
          updatedOrder[state.orderShippingID].months[newItem.month].itemCount = { ...updatedOrder[state.orderShippingID].months[newItem.month].itemCount, [newItem.brand]: updatedItemNumber };
          if (state.editBrand === 'Bonus') {
            if (oldOrder) {
              //console.log('this is my old ORder', oldOrder);
              if (newItem.item !== oldOrder.item) {
                updatedOrder[state.orderShippingID].months[newItem.month].bonusCount =
                  (updatedOrder[state.orderShippingID].months[newItem.month].bonusCount ? updatedOrder[state.orderShippingID].months[newItem.month].bonusCount + (itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1) : itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1) - (oldOrder.data.brand === 'Clear + Brilliant' ? oldOrder.quantiy * 2 : oldOrder.quantiy);
              } else {
                updatedOrder[state.orderShippingID].months[newItem.month].bonusCount = updatedOrder[state.orderShippingID].months[newItem.month].bonusCount ? updatedOrder[state.orderShippingID].months[newItem.month].bonusCount + (itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1) : itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1;
              }
            } else {
              updatedOrder[state.orderShippingID].months[newItem.month].bonusCount = updatedOrder[state.orderShippingID].months[newItem.month].bonusCount ? updatedOrder[state.orderShippingID].months[newItem.month].bonusCount + (itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1) : itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1;
            }
          }
        } else {
          updatedOrder.months[newItem.month].itemCount = { ...updatedOrder.months[newItem.month].itemCount, [newItem.brand]: updatedItemNumber };
          if (state.editBrand === 'Bonus') {
            if (oldOrder) {
              //console.log('this is my old ORder', oldOrder);
              if (newItem.item !== oldOrder.item) {
                updatedOrder.months[newItem.month].bonusCount = (updatedOrder.months[newItem.month].bonusCount ? updatedOrder.months[newItem.month].bonusCount + (itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1) : itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1) - (oldOrder.data.brand === 'Clear + Brilliant' ? oldOrder.quantiy * 2 : oldOrder.quantiy);
              } else {
                updatedOrder.months[newItem.month].bonusCount = updatedOrder.months[newItem.month].bonusCount ? updatedOrder.months[newItem.month].bonusCount + (itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1) : itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1;
              }
            } else {
              updatedOrder.months[newItem.month].bonusCount = updatedOrder.months[newItem.month].bonusCount ? updatedOrder.months[newItem.month].bonusCount + (itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1) : itemPricing[0].data.brand === 'Clear + Brilliant' ? 2 : 1;
            }
          }
        }

        //Calculate the TOTAL for the Month
        let monthTotal = getTotalNumberofSpend({ orderGroup: state.multipleIDs ? updatedOrder[state.orderShippingID].months[newItem.month][newItem.brand] : updatedOrder.months[newItem.month][newItem.brand] });
        if (state.multipleIDs) {
          updatedOrder[state.orderShippingID].months[newItem.month].total = { ...updatedOrder[state.orderShippingID].months[newItem.month].total, [newItem.brand]: monthTotal };
        } else {
          updatedOrder.months[newItem.month].total = { ...updatedOrder.months[newItem.month].total, [newItem.brand]: monthTotal };
        }

        //Calculate the TOTAL FOR THE WHOLE MONTH
        let monthTotalA = getMonthTotal({ orderGroup: state.multipleIDs ? updatedOrder[state.orderShippingID].months[newItem.month] : updatedOrder.months[newItem.month] });
        if (state.multipleIDs) {
          //console.log('this is my newItem Month', newItem.month);
          if (currentMonthTotal[state.orderShippingID][newItem.month]) {
            currentMonthTotal[state.orderShippingID][newItem.month].total = monthTotalA;
          } else {
            currentMonthTotal[state.orderShippingID][newItem.month + 6].total = monthTotalA;
          }
        } else {
          currentMonthTotal[newItem.month].total = monthTotalA;
        }

        //Calculate the TOTAL COSTS OVERALL
        let totalCost = totalAmount({ orderGroup: currentMonthTotal, multipleIDs: state.multipleIDs });
        //console.log('this is my current month Totals', currentMonthTotal);
        return {
          ...state,
          order: { ...updatedOrder },
          monthTotals: { ...currentMonthTotal },
          totalOrder: totalCost,
          orderChanged: true,
        };
      } else {
        //If the item is a bonus tip then add it here
        let itemPricing = state.items.filter((item) => item.data.sku === newItem.item);

        if (state.multipleIDs) {
          updatedOrder[state.orderShippingID].bonus[newItem.brand][newItem.row] = { item: newItem.item, quantiy: 1, data: itemPricing[0].data };
        } else {
          updatedOrder.bonus[newItem.brand][newItem.row] = { item: newItem.item, quantiy: 1, data: itemPricing[0].data };
        }

        //let newPrice = getItemPricing({ singleItem: newItem.item, allItems: state.items, autoShipTiers: state.autoShipTiers, autoShipCompany: state.autoShipCompany, programElevate: state.programElevate });

        //Calculate the total number of items
        if (state.multipleIDs) {
          let updatedItemNumber = getTotalNumberofItems({ orderGroup: updatedOrder[state.orderShippingID].bonus[newItem.brand] });
          updatedOrder[state.orderShippingID].bonus.itemCount = { ...updatedOrder[state.orderShippingID].bonus.itemCount, [newItem.brand]: updatedItemNumber };
        } else {
          let updatedItemNumber = getTotalNumberofItems({ orderGroup: updatedOrder.bonus[newItem.brand] });
          updatedOrder.bonus.itemCount = { ...updatedOrder.bonus.itemCount, [newItem.brand]: updatedItemNumber };
        }

        //WE will need to take it away from the amount of tips.
        //console.log('this is my update order', updatedOrder);
        return {
          ...state,
          order: { ...updatedOrder },
          promoTips: newItem.brand === 'Clear + Brilliant' ? state.promoTips - 2 : state.promoTips - 1,
        };
      }

    case 'ADD_QUANTITY_TO_ITEM_ORDER':
      let updatedQuantiyOrder = state.order;
      let currentMonthTotalQ = state.monthTotals;
      let newQuantityItem = action.resp;

      if (newQuantityItem.month !== 'bonus') {
        let newQuantity =
          action.resp.adjust === 'add'
            ? state.multipleIDs
              ? updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].quantiy + 1
              : updatedQuantiyOrder.months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].quantiy + 1
            : state.multipleIDs
            ? updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].quantiy - 1
            : updatedQuantiyOrder.months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].quantiy - 1;
        let newQuantityPrice =
          getItemPricing({
            singleItem: state.multipleIDs ? updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].item : updatedQuantiyOrder.months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].item,
            allItems: state.items,
            autoShipTiers: state.autoShipTiers,
            autoShipCompany: state.autoShipCompany,
            programElevate: state.programElevate,
          }) * newQuantity;

        if (newQuantity === 0) {
          state.multipleIDs ? (updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].item = '') : (updatedQuantiyOrder.months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].item = '');
        }

        if (state.multipleIDs) {
          updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].quantiy = newQuantity;
          updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].price = newQuantityItem.brand === 'Bonus' ? 0 : newQuantityPrice;
        } else {
          updatedQuantiyOrder.months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].quantiy = newQuantity;
          updatedQuantiyOrder.months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].price = newQuantityItem.brand === 'Bonus' ? 0 : newQuantityPrice;
        }

        //Update the bonusCount on add

        if (newQuantityItem.brand === 'Bonus') {
          if (state.multipleIDs) {
            if (action.resp.adjust === 'add') {
              updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month].bonusCount = updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month].bonusCount + (updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].data.brand === 'Clear + Brilliant' ? 2 : 1);
            } else {
              updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month].bonusCount = updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month].bonusCount - (updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].data.brand === 'Clear + Brilliant' ? 2 : 1);
            }
          } else {
            if (action.resp.adjust === 'add') {
              updatedQuantiyOrder.months[newQuantityItem.month].bonusCount = updatedQuantiyOrder.months[newQuantityItem.month].bonusCount + (updatedQuantiyOrder.months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].data.brand === 'Clear + Brilliant' ? 2 : 1);
            } else {
              updatedQuantiyOrder.months[newQuantityItem.month].bonusCount = updatedQuantiyOrder.months[newQuantityItem.month].bonusCount - (updatedQuantiyOrder.months[newQuantityItem.month][newQuantityItem.brand][newQuantityItem.row].data.brand === 'Clear + Brilliant' ? 2 : 1);
            }
          }
        }

        //Update the groups total count of items
        let updatedItemCount = getTotalNumberofItems({ orderGroup: state.multipleIDs ? updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month][newQuantityItem.brand] : updatedQuantiyOrder.months[newQuantityItem.month][newQuantityItem.brand] });
        state.multipleIDs
          ? (updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month].itemCount = { ...updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month].itemCount, [newQuantityItem.brand]: updatedItemCount })
          : (updatedQuantiyOrder.months[newQuantityItem.month].itemCount = { ...updatedQuantiyOrder.months[newQuantityItem.month].itemCount, [newQuantityItem.brand]: updatedItemCount });
        //console.log('this is my updated Item Count', updatedItemCount);

        let monthTotalQ = getTotalNumberofSpend({ orderGroup: state.multipleIDs ? updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month][newQuantityItem.brand] : updatedQuantiyOrder.months[newQuantityItem.month][newQuantityItem.brand] });

        state.multipleIDs
          ? (updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month].total = { ...updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month].total, [newQuantityItem.brand]: monthTotalQ })
          : (updatedQuantiyOrder.months[newQuantityItem.month].total = { ...updatedQuantiyOrder.months[newQuantityItem.month].total, [newQuantityItem.brand]: monthTotalQ });

        let monthQTotal = getMonthTotal({ orderGroup: state.multipleIDs ? updatedQuantiyOrder[state.orderShippingID].months[newQuantityItem.month] : updatedQuantiyOrder.months[newQuantityItem.month] });
        state.multipleIDs ? (currentMonthTotalQ[state.orderShippingID][newQuantityItem.month] ? (currentMonthTotalQ[state.orderShippingID][newQuantityItem.month].total = monthQTotal) : (currentMonthTotalQ[state.orderShippingID][newQuantityItem.month + 6].total = monthQTotal)) : (currentMonthTotalQ[newQuantityItem.month].total = monthQTotal);

        let totalCostQ = totalAmount({ orderGroup: currentMonthTotalQ, multipleIDs: state.multipleIDs });

        return {
          ...state,
          order: { ...updatedQuantiyOrder },
          monthTotals: { ...currentMonthTotalQ },
          totalOrder: totalCostQ,
          orderChanged: true,
        };
      } else {
        if (state.multipleIDs) {
          let newQuantity = action.resp.adjust === 'add' ? updatedQuantiyOrder[state.orderShippingID].bonus[newQuantityItem.brand][newQuantityItem.row].quantiy + 1 : updatedQuantiyOrder[state.orderShippingID].bonus[newQuantityItem.brand][newQuantityItem.row].quantiy - 1;
          updatedQuantiyOrder[state.orderShippingID].bonus[newQuantityItem.brand][newQuantityItem.row].quantiy = newQuantity;
        } else {
          let newQuantity = action.resp.adjust === 'add' ? updatedQuantiyOrder.bonus[newQuantityItem.brand][newQuantityItem.row].quantiy + 1 : updatedQuantiyOrder.bonus[newQuantityItem.brand][newQuantityItem.row].quantiy - 1;
          updatedQuantiyOrder.bonus[newQuantityItem.brand][newQuantityItem.row].quantiy = newQuantity;
        }

        //Update the groups total count of items
        if (state.multipleIDs) {
          let updatedItemCount = getTotalNumberofItems({ orderGroup: updatedQuantiyOrder[state.orderShippingID].bonus[newQuantityItem.brand] });
          updatedQuantiyOrder[state.orderShippingID].bonus.itemCount = { ...updatedQuantiyOrder[state.orderShippingID].bonus.itemCount, [newQuantityItem.brand]: updatedItemCount };
        } else {
          let updatedItemCount = getTotalNumberofItems({ orderGroup: updatedQuantiyOrder.bonus[newQuantityItem.brand] });
          updatedQuantiyOrder.bonus.itemCount = { ...updatedQuantiyOrder.bonus.itemCount, [newQuantityItem.brand]: updatedItemCount };
        }
        //console.log('this is my updated Item Count', updatedItemCount)

        return {
          ...state,
          order: { ...updatedQuantiyOrder },
          promoTips: action.resp.adjust === 'add' ? (newQuantityItem.brand === 'Clear + Brilliant' ? state.promoTips - 2 : state.promoTips - 1) : newQuantityItem.brand === 'Clear + Brilliant' ? state.promoTips + 2 : state.promoTips + 1,
          orderChanged: true,
        };
      }

    case 'ERROR_SEARCHING_FOR_AUTOSHIP_ORDER':
      return {
        ...state,
        autoShipError: action.err.message,
        autoShipErrorPopup: true,
      };
    case 'NO_AUTOSHIP_ORDER_FOUND':
      return {
        ...state,
        autoShipError: 'Sorry there is no order with that id',
        autoShipErrorPopup: true,
      };

    case 'AUTOSHIP_ORDER_FOUND': //This will be used to load the autoship data
      const autoshipOrder = action.resp;
      //console.log('this is my company', state.autoShipCompany);
      //If we have an order in the saved data then use that
      if (autoshipOrder.data.order) {
        if (state.autoShipCompany.data.shippingIDs) {
          const cbBonusTips = [];
          const TBonusTips = [];
          const FBonusTips = [];

          Object.keys(autoshipOrder.data.order.order).map((sID) => {
            if (autoshipOrder.data.order.order[sID].bonus.itemCount) {
              if (autoshipOrder.data.order.order[sID].bonus.itemCount['Clear + Brilliant']) {
                cbBonusTips.push(autoshipOrder.data.order.order[sID].bonus.itemCount['Clear + Brilliant'] * 2);
              }
              if (autoshipOrder.data.order.order[sID].bonus.itemCount.Thermage) {
                cbBonusTips.push(autoshipOrder.data.order.order[sID].bonus.itemCount.Thermage);
              }
              if (autoshipOrder.data.order.order[sID].bonus.itemCount.Fraxel) {
                cbBonusTips.push(autoshipOrder.data.order.order[sID].bonus.itemCount.Fraxel);
              }
            }
            return true;
          });

          const promoTipCal = (cbBonusTips.length > 0 ? cbBonusTips.reduce((a, b) => a + b) : 0) + (TBonusTips.length > 0 ? TBonusTips.reduce((a, b) => a + b) : 0) + (FBonusTips.length > 0 ? FBonusTips.reduce((a, b) => a + b) : 0);
          //console.log('this is my promoTip Cal', promoTipCal);

          return {
            ...state,
            order: autoshipOrder.data.order.order,
            loadFreshAutoShipOrder: false,
            autoShipOrderID: autoshipOrder.id,
            loadingAutoShipOrder: true,
            monthTotals: autoshipOrder.data.order.monthTotals,
            totalOrder: autoshipOrder.data.order.totalOrder,
            months: autoshipOrder.data.order.months,
            cbMonthItems: autoshipOrder.data.order.cbMonthItems,
            tMonthItems: autoshipOrder.data.order.tMonthItems,
            fMonthItems: autoshipOrder.data.order.fMonthItems,
            bItemsMonth: autoshipOrder.data.order.bItemsMonth,
            programElevate: autoshipOrder.data.order.programElevate,
            pricingTier: autoshipOrder.data.order.pricingTier,
            monthlyCommitment:
              state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
                ? autoshipOrder.data.order.programElevate
                  ? Math.round(state.autoShipCompany.naturalTier.tierElevateMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6))
                  : Math.round(state.autoShipCompany.naturalTier.tierMaintainMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6))
                : autoshipOrder.data.order.programElevate
                ? Math.round(state.autoShipCompany.pureTier.tierElevateMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6))
                : Math.round(state.autoShipCompany.pureTier.tierMaintainMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6)),
            minAutoshipCommitment:
              state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
                ? autoshipOrder.data.order.programElevate
                  ? state.autoShipCompany.naturalTier.tierElevateMin
                  : state.autoShipCompany.naturalTier.tierMaintainMin
                : autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.pureTier.tierElevateMin
                : state.autoShipCompany.pureTier.tierMaintainMin,
            minToKeep:
              state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
                ? autoshipOrder.data.order.programElevate
                  ? state.autoShipCompany.naturalTier.tierElevateTrueup
                  : state.autoShipCompany.naturalTier.tierMaintainTrueUp
                : autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.pureTier.tierElevateTrueup
                : state.autoShipCompany.pureTier.tierMaintainTrueUp,
            leftToFillAutoship: state.autoShipCompany.data.eliteProgram
              ? autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.naturalTier.tierMaintainMin
                : state.autoShipCompany.naturalTier.tierElevateMin
              : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
              ? autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.naturalTier.tierElevateMin
                : state.autoShipCompany.naturalTier.tierMaintainMin
              : autoshipOrder.data.order.programElevate
              ? state.autoShipCompany.pureTier.tierElevateMin
              : state.autoShipCompany.pureTier.tierMaintainMin,
            lefttoEarnAutoshipPromo: state.autoShipCompany.data.eliteProgram
              ? autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.naturalTier.tierMaintainMin
                : state.autoShipCompany.naturalTier.tierElevateMin
              : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
              ? autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.naturalTier.tierElevateTrueup
                : state.autoShipCompany.naturalTier.tierMaintainTrueUp
              : autoshipOrder.data.order.programElevate
              ? state.autoShipCompany.pureTier.tierElevateTrueup
              : state.autoShipCompany.pureTier.tierMaintainTrueUp,
            orderName: autoshipOrder.data.name ? autoshipOrder.data.name : '',
            promoTips:
              state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
                ? autoshipOrder.data.order.programElevate
                  ? state.autoShipCompany.naturalTier.elevatedPromoBonus - promoTipCal
                  : state.autoShipCompany.naturalTier.promoBonus - promoTipCal
                : autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.pureTier.elevatedPromoBonus - promoTipCal
                : state.autoShipCompany.pureTier.promoBonus - promoTipCal,
            multipleIDs: true,
            selectedShippingID: 0,
            orderShippingID: state.autoShipCompany.data.shippingIDs ? state.autoShipCompany.data.shippingIDs[0] : '',
            eliteCompany: state.autoShipCompany.data.eliteProgram ? state.autoShipCompany.data.eliteProgram : false,
          };
        } else {
          const cbBonusTips = autoshipOrder.data.order.order.bonus.itemCount ? (autoshipOrder.data.order.order.bonus.itemCount['Clear + Brilliant'] ? autoshipOrder.data.order.order.bonus.itemCount['Clear + Brilliant'] * 2 : 0) : 0;
          const TBonusTips = autoshipOrder.data.order.order.bonus.itemCount ? (autoshipOrder.data.order.order.bonus.itemCount.Thermage ? autoshipOrder.data.order.order.bonus.itemCount.Thermage : 0) : 0;
          const FBonusTips = autoshipOrder.data.order.order.bonus.itemCount ? (autoshipOrder.data.order.order.bonus.itemCount.Fraxel ? autoshipOrder.data.order.order.bonus.itemCount.Fraxel : 0) : 0;

          const promoTipCal = cbBonusTips + TBonusTips + FBonusTips;
          //console.log('this is my promoTip Cal', promoTipCal);
          console.log('this is my bItems', autoshipOrder.data.order);
          return {
            ...state,
            order: autoshipOrder.data.order.order,
            loadFreshAutoShipOrder: false,
            autoShipOrderID: autoshipOrder.id,
            loadingAutoShipOrder: true,
            monthTotals: autoshipOrder.data.order.monthTotals,
            totalOrder: autoshipOrder.data.order.totalOrder,
            months: autoshipOrder.data.order.months,
            cbMonthItems: autoshipOrder.data.order.cbMonthItems,
            tMonthItems: autoshipOrder.data.order.tMonthItems,
            fMonthItems: autoshipOrder.data.order.fMonthItems,
            bItemsMonth: autoshipOrder.data.order.bItemsMonth,
            programElevate: autoshipOrder.data.order.programElevate,
            pricingTier: autoshipOrder.data.order.pricingTier,
            monthlyCommitment:
              state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
                ? autoshipOrder.data.order.programElevate
                  ? Math.round(state.autoShipCompany.naturalTier.tierElevateMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6))
                  : Math.round(state.autoShipCompany.naturalTier.tierMaintainMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6))
                : autoshipOrder.data.order.programElevate
                ? Math.round(state.autoShipCompany.pureTier.tierElevateMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6))
                : Math.round(state.autoShipCompany.pureTier.tierMaintainMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6)),
            minAutoshipCommitment:
              state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
                ? autoshipOrder.data.order.programElevate
                  ? state.autoShipCompany.naturalTier.tierElevateMin
                  : state.autoShipCompany.naturalTier.tierMaintainMin
                : autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.pureTier.tierElevateMin
                : state.autoShipCompany.pureTier.tierMaintainMin,
            minToKeep:
              state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
                ? autoshipOrder.data.order.programElevate
                  ? state.autoShipCompany.naturalTier.tierElevateTrueup
                  : state.autoShipCompany.naturalTier.tierMaintainTrueUp
                : autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.pureTier.tierElevateTrueup
                : state.autoShipCompany.pureTier.tierMaintainTrueUp,
            leftToFillAutoship: state.autoShipCompany.data.eliteProgram
              ? autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.naturalTier.tierElevateMin
                : state.autoShipCompany.naturalTier.tierMaintainMin
              : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
              ? autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.naturalTier.tierElevateMin
                : state.autoShipCompany.naturalTier.tierMaintainMin
              : autoshipOrder.data.order.programElevate
              ? state.autoShipCompany.pureTier.tierElevateMin
              : state.autoShipCompany.pureTier.tierMaintainMin,
            lefttoEarnAutoshipPromo: state.autoShipCompany.data.eliteProgram
              ? autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.naturalTier.tierElevateMin
                : state.autoShipCompany.naturalTier.tierMaintainMin
              : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
              ? autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.naturalTier.tierElevateTrueup
                : state.autoShipCompany.naturalTier.tierMaintainTrueUp
              : autoshipOrder.data.order.programElevate
              ? state.autoShipCompany.pureTier.tierElevateTrueup
              : state.autoShipCompany.pureTier.tierMaintainTrueUp,
            orderName: autoshipOrder.data.name ? autoshipOrder.data.name : '',
            promoTips:
              state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
                ? autoshipOrder.data.order.programElevate
                  ? state.autoShipCompany.naturalTier.elevatedPromoBonus - promoTipCal
                  : state.autoShipCompany.naturalTier.promoBonus - promoTipCal
                : autoshipOrder.data.order.programElevate
                ? state.autoShipCompany.pureTier.elevatedPromoBonus - promoTipCal
                : state.autoShipCompany.pureTier.promoBonus - promoTipCal,
            multipleIDs: false,
            eliteCompany: state.autoShipCompany.data.eliteProgram ? state.autoShipCompany.data.eliteProgram : false,
          };
        }
      } else {
        return {
          ...state,
          autoShipOrderID: autoshipOrder.id,
          loadingAutoShipOrder: true,
          orderName: autoshipOrder.data.name ? autoshipOrder.data.name : '',
          programElevate: state.autoShipCompany.pureTier.tierName !== 'Silver' ? false : true,
          monthlyCommitment:
            state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
              ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
                ? Math.round(state.autoShipCompany.naturalTier.tierMaintainMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6))
                : Math.round(state.autoShipCompany.naturalTier.tierElevateMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6))
              : state.autoShipCompany.pureTier.tierName !== 'Silver'
              ? Math.round(state.autoShipCompany.pureTier.tierMaintainMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6))
              : Math.round(state.autoShipCompany.pureTier.tierElevateMin / (state.autoShipCompany.data.eliteProgram ? 12 : 6)),
          minAutoshipCommitment:
            state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
              ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
                ? state.autoShipCompany.naturalTier.tierMaintainMin
                : state.autoShipCompany.naturalTier.tierElevateMin
              : state.autoShipCompany.pureTier.tierName !== 'Silver'
              ? state.autoShipCompany.pureTier.tierMaintainMin
              : state.autoShipCompany.pureTier.tierElevateMin,
          minToKeep:
            state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
              ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
                ? state.autoShipCompany.naturalTier.tierMaintainTrueUp
                : state.autoShipCompany.naturalTier.tierElevateTrueup
              : state.autoShipCompany.pureTier.tierName !== 'Silver'
              ? state.autoShipCompany.pureTier.tierMaintainTrueUp
              : state.autoShipCompany.pureTier.tierElevateTrueup,
          leftToFillAutoship: state.autoShipCompany.data.eliteProgram
            ? state.autoShipCompany.naturalTier.tierMaintainMin
            : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
            ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
              ? state.autoShipCompany.naturalTier.tierMaintainMin
              : state.autoShipCompany.naturalTier.tierElevateMin
            : state.autoShipCompany.pureTier.tierName !== 'Silver'
            ? state.autoShipCompany.pureTier.tierMaintainMin
            : state.autoShipCompany.pureTier.tierElevateMin,
          lefttoEarnAutoshipPromo: state.autoShipCompany.data.eliteProgram
            ? state.autoShipCompany.naturalTier.tierMaintainMin
            : state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
            ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
              ? state.autoShipCompany.naturalTier.tierMaintainTrueUp
              : state.autoShipCompany.naturalTier.tierElevateTrueup
            : state.autoShipCompany.pureTier.tierName !== 'Silver'
            ? state.autoShipCompany.pureTier.tierMaintainTrueUp
            : state.autoShipCompany.pureTier.tierElevateTrueup,
          promoTips:
            state.autoShipCompany.pureTier.tierName !== state.autoShipCompany.naturalTier.tierName
              ? state.autoShipCompany.naturalTier.tierName !== 'Silver'
                ? state.autoShipCompany.naturalTier.promoBonus
                : state.autoShipCompany.naturalTier.elevatedPromoBonus
              : state.autoShipCompany.pureTier.tierName !== 'Silver'
              ? state.autoShipCompany.pureTier.promoBonus
              : state.autoShipCompany.pureTier.elevatedPromoBonus,
          multipleIDs: state.autoShipCompany.data.shippingIDs ? true : false,
          selectedShippingID: 0,
          orderShippingID: state.autoShipCompany.data.shippingIDs ? state.autoShipCompany.data.shippingIDs[0] : '',
          eliteCompany: state.autoShipCompany.data.eliteProgram ? state.autoShipCompany.data.eliteProgram : false,
        };
      }

    case 'AUTOSHIP_ORDER_AND_CLINIC_FOUND': //This will be used to load the autoship data and clinic
      //console.log(action.clinic);
      const autoshipOrderC = action.resp;

      //console.log('this is my data from the response ---> ', autoshipOrderC);

      if (autoshipOrderC.data.order) {
        if (autoshipOrderC.clinic.data.shippingIDs) {
          const cbBonusTips = [];
          const TBonusTips = [];
          const FBonusTips = [];

          Object.keys(autoshipOrderC.data.order.order).map((sID) => {
            if (autoshipOrderC.data.order.order[sID].bonus.itemCount) {
              if (autoshipOrderC.data.order.order[sID].bonus.itemCount['Clear + Brilliant']) {
                cbBonusTips.push(autoshipOrderC.data.order.order[sID].bonus.itemCount['Clear + Brilliant'] * 2);
              }
              if (autoshipOrderC.data.order.order[sID].bonus.itemCount.Thermage) {
                TBonusTips.push(autoshipOrderC.data.order.order[sID].bonus.itemCount.Thermage);
              }
              if (autoshipOrderC.data.order.order[sID].bonus.itemCount.Fraxel) {
                FBonusTips.push(autoshipOrderC.data.order.order[sID].bonus.itemCount.Fraxel);
              }
            }
            return true;
          });

          const promoTipCal = (cbBonusTips.length > 0 ? cbBonusTips.reduce((a, b) => a + b) : 0) + (TBonusTips.length > 0 ? TBonusTips.reduce((a, b) => a + b) : 0) + (FBonusTips.length > 0 ? FBonusTips.reduce((a, b) => a + b) : 0);
          //console.log('loading in the variables for the pricing list from the order', autoshipOrderC.data.order.pricingTier);

          //console.log('this is my order that I am loading where if my data???? --> ', autoshipOrderC.data.order.order);
          console.log('Ths is my pricing tier ---> ', autoshipOrderC.data.order.pricingTier);

          return {
            ...state,
            order: autoshipOrderC.data.order.order,
            monthTotals: autoshipOrderC.data.order.monthTotals,
            totalOrder: autoshipOrderC.data.order.totalOrder,
            months: autoshipOrderC.data.order.months,
            cbMonthItems: autoshipOrderC.data.order.cbMonthItems,
            tMonthItems: autoshipOrderC.data.order.tMonthItems,
            fMonthItems: autoshipOrderC.data.order.fMonthItems,
            bItemsMonth: autoshipOrderC.data.order.bItemsMonth,
            autoShipOrderID: action.resp.id,
            loadingAutoShipOrder: true,
            autoShipCompany: action.resp.clinic,
            orderShippingID: action.resp.clinic.data.shippingIDs ? action.resp.clinic.data.shippingIDs[0] : '',
            eliteCompany: action.resp.clinic.data.eliteProgram ? action.resp.clinic.data.eliteProgram : false,
            clinicLoaded: true,
            pricingTier: autoshipOrderC.data.order.pricingTier,
            loadFreshAutoShipOrder: false,
            programElevate: autoshipOrderC.data.order.programElevate,
            monthlyCommitment:
              action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
                ? autoshipOrderC.data.order.programElevate
                  ? Math.round(action.resp.clinic.naturalTier.tierElevateMin / (action.resp.clinic.data.eliteProgram ? 12 : 6))
                  : Math.round(action.resp.clinic.naturalTier.tierMaintainMin / (action.resp.clinic.data.eliteProgram ? 12 : 6))
                : autoshipOrderC.data.order.programElevate
                ? Math.round(action.resp.clinic.pureTier.tierElevateMin / (action.resp.clinic.data.eliteProgram ? 12 : 6))
                : Math.round(action.resp.clinic.pureTier.tierMaintainMin / (action.resp.clinic.data.eliteProgram ? 12 : 6)),
            minAutoshipCommitment:
              action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate ? (autoshipOrderC.data.order.programElevate ? action.resp.clinic.naturalTier.tierElevateMin : action.resp.clinic.naturalTier.tierMaintainMin) : autoshipOrderC.data.order.programElevate ? action.resp.clinic.pureTier.tierElevateMin : action.resp.clinic.pureTier.tierMaintainMin,
            minToKeep:
              action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
                ? autoshipOrderC.data.order.programElevate
                  ? action.resp.clinic.naturalTier.tierElevateTrueup
                  : action.resp.clinic.naturalTier.tierMaintainTrueUp
                : autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.pureTier.tierElevateTrueup
                : action.resp.clinic.pureTier.tierMaintainTrueUp,
            leftToFillAutoship: action.resp.clinic.data.eliteProgram
              ? autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.naturalTier.tierElevateMin
                : action.resp.clinic.naturalTier.tierMaintainMin
              : action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
              ? autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.naturalTier.tierElevateMin
                : action.resp.clinic.naturalTier.tierMaintainMin
              : autoshipOrderC.data.order.programElevate
              ? action.resp.clinic.pureTier.tierElevateMin
              : action.resp.clinic.pureTier.tierMaintainMin,
            lefttoEarnAutoshipPromo: action.resp.clinic.data.eliteProgram
              ? autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.naturalTier.tierElevateMin
                : action.resp.clinic.naturalTier.tierMaintainMin
              : action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
              ? autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.naturalTier.tierElevateTrueup
                : action.resp.clinic.naturalTier.tierMaintainTrueUp
              : autoshipOrderC.data.order.programElevate
              ? action.resp.clinic.pureTier.tierElevateTrueup
              : action.resp.clinic.pureTier.tierMaintainTrueUp,
            promoTips:
              action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
                ? autoshipOrderC.data.order.programElevate
                  ? action.resp.clinic.naturalTier.elevatedPromoBonus - promoTipCal
                  : action.resp.clinic.naturalTier.promoBonus - promoTipCal
                : autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.pureTier.elevatedPromoBonus - promoTipCal
                : action.resp.clinic.pureTier.promoBonus - promoTipCal,
            autoShipCreatorUserID: autoshipOrderC.data.userID,
            orderName: autoshipOrderC.data.name ? autoshipOrderC.data.name : '',
            multipleIDs: true,
            selectedShippingID: 0,
          };
        } else {
          const cbBonusTips = autoshipOrderC.data.order.order.bonus.itemCount ? (autoshipOrderC.data.order.order.bonus.itemCount['Clear + Brilliant'] ? autoshipOrderC.data.order.order.bonus.itemCount['Clear + Brilliant'] * 2 : 0) : 0;
          const TBonusTips = autoshipOrderC.data.order.order.bonus.itemCount ? (autoshipOrderC.data.order.order.bonus.itemCount.Thermage ? autoshipOrderC.data.order.order.bonus.itemCount.Thermage : 0) : 0;
          const FBonusTips = autoshipOrderC.data.order.order.bonus.itemCount ? (autoshipOrderC.data.order.order.bonus.itemCount.Fraxel ? autoshipOrderC.data.order.order.bonus.itemCount.Fraxel : 0) : 0;

          const promoTipCal = cbBonusTips + TBonusTips + FBonusTips;

          return {
            ...state,
            order: autoshipOrderC.data.order.order,
            monthTotals: autoshipOrderC.data.order.monthTotals,
            totalOrder: autoshipOrderC.data.order.totalOrder,
            months: autoshipOrderC.data.order.months,
            cbMonthItems: autoshipOrderC.data.order.cbMonthItems,
            tMonthItems: autoshipOrderC.data.order.tMonthItems,
            fMonthItems: autoshipOrderC.data.order.fMonthItems,
            bItemsMonth: autoshipOrderC.data.order.bItemsMonth,
            autoShipOrderID: action.resp.id,
            loadingAutoShipOrder: true,
            autoShipCompany: action.resp.clinic,
            orderShippingID: action.resp.clinic.data.shippingIDs ? action.resp.clinic.data.shippingIDs[0] : '',
            eliteCompany: action.resp.clinic.data.eliteProgram ? action.resp.clinic.data.eliteProgram : false,
            clinicLoaded: true,
            pricingTier: autoshipOrderC.data.order.pricingTier,
            loadFreshAutoShipOrder: false,
            programElevate: autoshipOrderC.data.order.programElevate,
            monthlyCommitment:
              action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
                ? autoshipOrderC.data.order.programElevate
                  ? Math.round(action.resp.clinic.naturalTier.tierElevateMin / (action.resp.clinic.data.eliteProgram ? 12 : 6))
                  : Math.round(action.resp.clinic.naturalTier.tierMaintainMin / (action.resp.clinic.data.eliteProgram ? 12 : 6))
                : autoshipOrderC.data.order.programElevate
                ? Math.round(action.resp.clinic.pureTier.tierElevateMin / (action.resp.clinic.data.eliteProgram ? 12 : 6))
                : Math.round(action.resp.clinic.pureTier.tierMaintainMin / (action.resp.clinic.data.eliteProgram ? 12 : 6)),
            minAutoshipCommitment:
              action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate ? (autoshipOrderC.data.order.programElevate ? action.resp.clinic.naturalTier.tierElevateMin : action.resp.clinic.naturalTier.tierMaintainMin) : autoshipOrderC.data.order.programElevate ? action.resp.clinic.pureTier.tierElevateMin : action.resp.clinic.pureTier.tierMaintainMin,
            minToKeep:
              action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
                ? autoshipOrderC.data.order.programElevate
                  ? action.resp.clinic.naturalTier.tierElevateTrueup
                  : action.resp.clinic.naturalTier.tierMaintainTrueUp
                : autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.pureTier.tierElevateTrueup
                : action.resp.clinic.pureTier.tierMaintainTrueUp,
            leftToFillAutoship: action.resp.clinic.data.eliteProgram
              ? autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.naturalTier.tierElevateMin
                : action.resp.clinic.naturalTier.tierMaintainMin
              : action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
              ? autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.naturalTier.tierElevateMin
                : action.resp.clinic.naturalTier.tierMaintainMin
              : autoshipOrderC.data.order.programElevate
              ? action.resp.clinic.pureTier.tierElevateMin
              : action.resp.clinic.pureTier.tierMaintainMin,
            lefttoEarnAutoshipPromo: action.resp.clinic.data.eliteProgram
              ? autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.naturalTier.tierElevateMin
                : action.resp.clinic.naturalTier.tierMaintainMin
              : action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
              ? autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.naturalTier.tierElevateTrueup
                : action.resp.clinic.naturalTier.tierMaintainTrueUp
              : autoshipOrderC.data.order.programElevate
              ? action.resp.clinic.pureTier.tierElevateTrueup
              : action.resp.clinic.pureTier.tierMaintainTrueUp,
            promoTips:
              action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
                ? autoshipOrderC.data.order.programElevate
                  ? action.resp.clinic.naturalTier.elevatedPromoBonus - promoTipCal
                  : action.resp.clinic.naturalTier.promoBonus - promoTipCal
                : autoshipOrderC.data.order.programElevate
                ? action.resp.clinic.pureTier.elevatedPromoBonus - promoTipCal
                : action.resp.clinic.pureTier.promoBonus - promoTipCal,
            autoShipCreatorUserID: autoshipOrderC.data.userID,
            orderName: autoshipOrderC.data.name ? autoshipOrderC.data.name : '',
          };
        }
      } else {
        //console.log('loading in the variables for the pricing list with out an order', action.resp.clinic.pureTier.id);

        return {
          ...state,
          //order: autoshipOrder.data.order,
          autoShipOrderID: action.resp.id,
          loadingAutoShipOrder: true,
          autoShipCompany: action.resp.clinic,
          orderShippingID: action.resp.clinic.data.shippingIDs ? action.resp.clinic.data.shippingIDs[0] : '',
          eliteCompany: action.resp.clinic.data.eliteProgram ? action.resp.clinic.data.eliteProgram : false,
          clinicLoaded: true,
          pricingTier: action.resp.clinic.pureTier.tierName !== 'Silver' ? (action.resp.clinic.pureTier.tierName !== 'Bronze' ? action.resp.clinic.pureTier.id : '3IaLvKVToLsbcC8neru7') : 'hfgJtLRuei3Ac42Gu1tj',
          programElevate: action.resp.clinic.pureTier.tierName !== 'Silver' ? false : true,
          monthlyCommitment:
            action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
              ? action.resp.clinic.naturalTier.tierName !== 'Silver'
                ? Math.round(action.resp.clinic.naturalTier.tierMaintainMin / 6)
                : Math.round(action.resp.clinic.naturalTier.tierElevateMin / 6)
              : action.resp.clinic.pureTier.tierName !== 'Silver'
              ? Math.round(action.resp.clinic.pureTier.tierMaintainMin / 6)
              : Math.round(action.resp.clinic.pureTier.tierElevateMin / 6),
          minAutoshipCommitment:
            action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
              ? action.resp.clinic.naturalTier.tierName !== 'Silver'
                ? action.resp.clinic.naturalTier.tierMaintainMin
                : action.resp.clinic.naturalTier.tierElevateMin
              : action.resp.clinic.pureTier.tierName !== 'Silver'
              ? action.resp.clinic.pureTier.tierMaintainMin
              : action.resp.clinic.pureTier.tierElevateMin,
          minToKeep:
            action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
              ? action.resp.clinic.naturalTier.tierName !== 'Silver'
                ? action.resp.clinic.naturalTier.tierMaintainTrueUp
                : action.resp.clinic.naturalTier.tierElevateTrueup
              : action.resp.clinic.pureTier.tierName !== 'Silver'
              ? action.resp.clinic.pureTier.tierMaintainTrueUp
              : action.resp.clinic.pureTier.tierElevateTrueup,
          leftToFillAutoship:
            action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
              ? action.resp.clinic.naturalTier.tierName !== 'Silver'
                ? action.resp.clinic.naturalTier.tierMaintainMin
                : action.resp.clinic.naturalTier.tierElevateMin
              : action.resp.clinic.pureTier.tierName !== 'Silver'
              ? action.resp.clinic.pureTier.tierMaintainMin
              : action.resp.clinic.pureTier.tierElevateMin,
          lefttoEarnAutoshipPromo:
            action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
              ? action.resp.clinic.naturalTier.tierName !== 'Silver'
                ? action.resp.clinic.naturalTier.tierMaintainTrueUp
                : action.resp.clinic.naturalTier.tierElevateTrueup
              : action.resp.clinic.pureTier.tierName !== 'Silver'
              ? action.resp.clinic.pureTier.tierMaintainTrueUp
              : action.resp.clinic.pureTier.tierElevateTrueup,
          promoTips:
            action.resp.clinic.pureTier.tierName === action.resp.clinic.naturalTier.tierElevate
              ? action.resp.clinic.naturalTier.tierName !== 'Silver'
                ? action.resp.clinic.naturalTier.promoBonus
                : action.resp.clinic.naturalTier.elevatedPromoBonus
              : action.resp.clinic.pureTier.tierName !== 'Silver'
              ? action.resp.clinic.pureTier.promoBonus
              : action.resp.clinic.pureTier.elevatedPromoBonus,
          autoShipCreatorUserID: autoshipOrderC.data.userID,
          orderName: autoshipOrderC.data.name ? autoshipOrderC.data.name : '',
        };
      }

    case 'STARTING_SAVING_ORDER':
      return {
        ...state,
        savingOrder: true,
      };

    case 'AUTOSHIP_ORDER_WAS_SAVED':
      return {
        ...state,
        savingOrder: false,
        autoShipMessage: 'Your order was saved',
        autoShipPopUp: true,
        orderChanged: false,
      };
    case 'ERROR_SAVING_AUTOSHIP_ORDER':
      return {
        ...state,
        autoShipError: action.err.message,
        autoShipErrorPopup: true,
      };

    case 'COPY_MONTH_ORDER':
      const monthCopy = state.multipleIDs ? state.order[state.orderShippingID].months[action.month] : state.order.months[action.month];
      const copyItemCount = monthCopy.itemCount;
      const copyTotal = monthCopy.total;

      //I have to create a clean order
      if (state.multipleIDs) {
        const cleanOrder = {};

        const copyMonthTotals = state.monthTotals;
        //I need to go through all of the shipping IDs
        state.autoShipCompany.data.shippingIDs.map((sID) => {
          console.log('this is my ssid --> ', sID);
          cleanOrder[sID] = {};
          cleanOrder[sID].months = {};

          state.months.map((m, mi) => {
            return (cleanOrder[sID].months[mi] = { ...m, 'Clear + Brilliant': [], Thermage: [], Fraxel: [], Bonus: [] });
          });

          cleanOrder[sID].bonus = { ...state.order[sID].bonus };

          const monthTotalCopy = state.monthTotals[state.orderShippingID][action.month] ? state.monthTotals[state.orderShippingID][action.month] : state.monthTotals[state.orderShippingID][action.month + 6];

          Object.keys(cleanOrder[sID].months).map((o, i) => {
            //Copy the months data over to the specific order
            if (sID === state.orderShippingID) {
              Object.keys(monthCopy['Clear + Brilliant']).map((k, j) => {
                return (cleanOrder[sID].months[o]['Clear + Brilliant'][k] = { item: monthCopy['Clear + Brilliant'][k].item, quantiy: monthCopy['Clear + Brilliant'][k].quantiy, data: { ...monthCopy['Clear + Brilliant'][k].data }, price: monthCopy['Clear + Brilliant'][k].price });
              });

              Object.keys(monthCopy['Fraxel']).map((k, j) => {
                return (cleanOrder[sID].months[o]['Fraxel'][k] = { item: monthCopy['Fraxel'][k].item, quantiy: monthCopy['Fraxel'][k].quantiy, data: { ...monthCopy['Fraxel'][k].data }, price: monthCopy['Fraxel'][k].price });
              });

              Object.keys(monthCopy['Thermage']).map((k, j) => {
                return (cleanOrder[sID].months[o]['Thermage'][k] = { item: monthCopy['Thermage'][k].item, quantiy: monthCopy['Thermage'][k].quantiy, data: { ...monthCopy['Thermage'][k].data }, price: monthCopy['Thermage'][k].price });
              });

              Object.keys(monthCopy['Bonus']).map((k, j) => {
                return (cleanOrder[sID].months[i]['Bonus'][k] = { item: monthCopy['Bonus'][k].item, quantiy: monthCopy['Bonus'][k].quantiy, data: { ...monthCopy['Bonus'][k].data }, price: monthCopy['Bonus'][k].price });
              });

              cleanOrder[sID].months[o].itemCount = copyItemCount ? copyItemCount : 0;
              cleanOrder[sID].months[o].bonusCount = monthCopy.bonusCount ? monthCopy.bonusCount : 0;
              cleanOrder[sID].months[o].total = copyTotal ? copyTotal : 0;
            } else {
              //I need to loop through the old order and copy in the data
              Object.keys(state.order[sID].months[o]['Clear + Brilliant']).map((k, j) => {
                return (cleanOrder[sID].months[o]['Clear + Brilliant'][k] = { item: state.order[sID].months[o]['Clear + Brilliant'][k].item, quantiy: state.order[sID].months[o]['Clear + Brilliant'][k].quantiy, data: { ...state.order[sID].months[o]['Clear + Brilliant'][k].data }, price: state.order[sID].months[o]['Clear + Brilliant'][k].price });
              });

              Object.keys(state.order[sID].months[o]['Fraxel']).map((k, j) => {
                return (cleanOrder[sID].months[o]['Fraxel'][k] = { item: state.order[sID].months[o]['Fraxel'][k].item, quantiy: state.order[sID].months[o]['Fraxel'][k].quantiy, data: { ...state.order[sID].months[o]['Fraxel'][k].data }, price: state.order[sID].months[o]['Fraxel'][k].price });
              });

              Object.keys(state.order[sID].months[o]['Thermage']).map((k, j) => {
                return (cleanOrder[sID].months[o]['Thermage'][k] = { item: state.order[sID].months[o]['Thermage'][k].item, quantiy: state.order[sID].months[o]['Thermage'][k].quantiy, data: { ...state.order[sID].months[o]['Thermage'][k].data }, price: state.order[sID].months[o]['Thermage'][k].price });
              });

              Object.keys(state.order[sID].months[o]['Bonus']).map((k, j) => {
                return (cleanOrder[sID].months[i]['Bonus'][k] = { item: state.order[sID].months[o]['Bonus'][k].item, quantiy: state.order[sID].months[o]['Bonus'][k].quantiy, data: { ...state.order[sID].months[o]['Bonus'][k].data }, price: state.order[sID].months[o]['Bonus'][k].price });
              });

              cleanOrder[sID].months[o].itemCount = state.order[sID].months[o].itemCount ? state.order[sID].months[o].itemCount : 0;
              cleanOrder[sID].months[o].bonusCount = state.order[sID].months[o].bonusCount ? state.order[sID].months[o].bonusCount : 0;
              cleanOrder[sID].months[o].total = state.order[sID].months[o].total ? state.order[sID].months[o].total : 0;
            }

            return null;
          });

          Object.keys(state.monthTotals).map((sID, i) => {
            Object.keys(state.monthTotals[sID]).map((m) => {
              if (sID === state.orderShippingID) {
                console.log('this is my m', m);
                console.log('this is my copyMonthTotlas', copyMonthTotals[sID]);
                console.log('this is my monthTotal copy', monthTotalCopy);
                return (copyMonthTotals[sID][m].total = monthTotalCopy.total);
              }
              return true;
            });
            return true;
          });
          return true;
        });

        let copyTotalOrder = totalAmount({ orderGroup: copyMonthTotals, multipleIDs: state.multipleIDs });

        //console.log('this is my clean order', cleanOrder);
        return {
          ...state,
          order: { ...cleanOrder },
          monthTotals: { ...copyMonthTotals },
          totalOrder: copyTotalOrder,
          orderChanged: true,
        };
      } else {
        const cleanOrder = [];
        cleanOrder.months = [];

        state.months.map((m, mi) => {
          return cleanOrder.months.push({ ...m, 'Clear + Brilliant': [], Thermage: [], Fraxel: [], Bonus: [] });
        });

        cleanOrder.bonus = { ...state.order.bonus };

        const monthTotalCopy = state.monthTotals[action.month];
        const copyMonthTotals = state.monthTotals;

        //console.log('this is my my month Ciopy', monthCopy);

        cleanOrder.months.map((o, i) => {
          console.log('this is my montCopy');
          if (Array.isArray(monthCopy['Clear + Brilliant'])) {
            monthCopy['Clear + Brilliant'].map((k, j) => {
              return (cleanOrder.months[i]['Clear + Brilliant'][j] = { item: k.item, quantiy: k.quantiy, data: { ...k.data }, price: k.price });
            });
          } else {
            Object.keys(monthCopy['Clear + Brilliant']).map((k, j) => {
              return (cleanOrder.months[i]['Clear + Brilliant'][j] = { item: monthCopy['Clear + Brilliant'][k].item, quantiy: monthCopy['Clear + Brilliant'][k].quantiy, data: { ...monthCopy['Clear + Brilliant'][k].data }, price: monthCopy['Clear + Brilliant'][k].price });
            });
          }

          if (Array.isArray(monthCopy['Fraxel'])) {
            monthCopy['Fraxel'].map((k, j) => {
              return (cleanOrder.months[i]['Fraxel'][j] = { item: k.item, quantiy: k.quantiy, data: { ...k.data }, price: k.price });
            });
          } else {
            Object.keys(monthCopy['Fraxel']).map((k, j) => {
              return (cleanOrder.months[i]['Fraxel'][j] = { item: monthCopy['Fraxel'][k].item, quantiy: monthCopy['Fraxel'][k].quantiy, data: { ...monthCopy['Fraxel'][k].data }, price: monthCopy['Fraxel'][k].price });
            });
          }

          if (Array.isArray(monthCopy['Thermage'])) {
            monthCopy['Thermage'].map((k, j) => {
              return (cleanOrder.months[i]['Thermage'][j] = { item: k.item, quantiy: k.quantiy, data: { ...k.data }, price: k.price });
            });
          } else {
            Object.keys(monthCopy['Thermage']).map((k, j) => {
              return (cleanOrder.months[i]['Thermage'][j] = { item: monthCopy['Thermage'][k].item, quantiy: monthCopy['Thermage'][k].quantiy, data: { ...monthCopy['Thermage'][k].data }, price: monthCopy['Thermage'][k].price });
            });
          }

          if (monthCopy['Bonus']) {
            if (Array.isArray(monthCopy['Bonus'])) {
              monthCopy['Bonus'].map((k, j) => {
                return (cleanOrder.months[i]['Bonus'][j] = { item: k.item, quantiy: k.quantiy, data: { ...k.data }, price: k.price });
              });
            } else {
              Object.keys(monthCopy['Bonus']).map((k, j) => {
                return (cleanOrder.months[i]['Bonus'][j] = { item: monthCopy['Bonus'][k].item, quantiy: monthCopy['Bonus'][k].quantiy, data: { ...monthCopy['Bonus'][k].data }, price: monthCopy['Bonus'][k].price });
              });
            }
          }

          cleanOrder.months[i].itemCount = copyItemCount ? copyItemCount : 0;
          cleanOrder.months[i].bonusCount = monthCopy.bonusCount ? monthCopy.bonusCount : 0;
          cleanOrder.months[i].total = copyTotal ? copyTotal : 0;
          return null;
        });

        if (Array.isArray(state.monthTotals)) {
          state.monthTotals.map((t, i) => {
            return (copyMonthTotals[i].total = monthTotalCopy.total);
          });
        } else {
          Object.keys(state.monthTotals).map((t, i) => {
            return (copyMonthTotals[t].total = monthTotalCopy.total);
          });
        }

        let copyTotalOrder = totalAmount({ orderGroup: copyMonthTotals, multipleIDs: state.multipleIDs });

        //console.log('this is my new copyTotalOrder', copyTotalOrder);

        return {
          ...state,
          order: { ...cleanOrder },
          monthTotals: { ...copyMonthTotals },
          totalOrder: copyTotalOrder,
          orderChanged: true,
        };
      }

    case 'COPY_SHIPPING_ID_ORDER':
      const shippingIDCopy = { ...state.order[state.orderShippingID] };

      const cleanOrder = {};

      const monthTotalCopyID = state.monthTotals[state.orderShippingID];
      const copyMonthTotals = state.monthTotals;
      console.log('this is my copyMonthTotals', copyMonthTotals);
      //I need to go through all of the shipping IDs
      state.autoShipCompany.data.shippingIDs.map((sID) => {
        cleanOrder[sID] = {};
        cleanOrder[sID].months = {};

        state.months.map((m, mi) => {
          return (cleanOrder[sID].months[mi] = { ...m, 'Clear + Brilliant': [], Thermage: [], Fraxel: [], Bonus: [] });
        });

        cleanOrder[sID].bonus = { ...state.order[sID].bonus };

        //const monthTotalCopy = state.monthTotals[state.orderShippingID];

        Object.keys(cleanOrder[sID].months).map((o, i) => {
          Object.keys(shippingIDCopy.months[o]['Clear + Brilliant']).map((k, j) => {
            return (cleanOrder[sID].months[o]['Clear + Brilliant'][k] = { item: shippingIDCopy.months[o]['Clear + Brilliant'][k].item, quantiy: shippingIDCopy.months[o]['Clear + Brilliant'][k].quantiy, data: { ...shippingIDCopy.months[o]['Clear + Brilliant'][k].data }, price: shippingIDCopy.months[o]['Clear + Brilliant'][k].price });
          });

          Object.keys(shippingIDCopy.months[o]['Fraxel']).map((k, j) => {
            return (cleanOrder[sID].months[o]['Fraxel'][k] = { item: shippingIDCopy.months[o]['Fraxel'][k].item, quantiy: shippingIDCopy.months[o]['Fraxel'][k].quantiy, data: { ...shippingIDCopy.months[o]['Fraxel'][k].data }, price: shippingIDCopy.months[o]['Fraxel'][k].price });
          });

          Object.keys(shippingIDCopy.months[o]['Thermage']).map((k, j) => {
            return (cleanOrder[sID].months[o]['Thermage'][k] = { item: shippingIDCopy.months[o]['Thermage'][k].item, quantiy: shippingIDCopy.months[o]['Thermage'][k].quantiy, data: { ...shippingIDCopy.months[o]['Thermage'][k].data }, price: shippingIDCopy.months[o]['Thermage'][k].price });
          });

          Object.keys(shippingIDCopy.months[o]['Bonus']).map((k, j) => {
            return (cleanOrder[sID].months[i]['Bonus'][k] = { item: shippingIDCopy.months[o]['Bonus'][k].item, quantiy: shippingIDCopy.months[o]['Bonus'][k].quantiy, data: { ...shippingIDCopy.months[o]['Bonus'][k].data }, price: shippingIDCopy.months[o]['Bonus'][k].price });
          });

          cleanOrder[sID].months[o].itemCount = shippingIDCopy.months[o].itemCount;
          cleanOrder[sID].months[o].bonusCount = shippingIDCopy.months[o].bonusCount;
          cleanOrder[sID].months[o].total = shippingIDCopy.months[o].total;
          return null;
        });

        Object.keys(state.monthTotals).map((sID, i) => {
          Object.keys(state.monthTotals[sID]).map((m) => {
            return (copyMonthTotals[sID][m].total = monthTotalCopyID[m].total);
          });
          return true;
        });
        return true;
      });

      let copyTotalOrder = totalAmount({ orderGroup: copyMonthTotals, multipleIDs: state.multipleIDs });
      //console.log('this is my new copyTotalOrder', copyTotalOrder);

      return {
        ...state,
        order: { ...cleanOrder },
        monthTotals: { ...copyMonthTotals },
        totalOrder: copyTotalOrder,
        orderChanged: true,
      };

    case 'EXIT_AUTOSHIP_ORDER':
      return {
        ...state,
        loadingAutoShipOrder: false,
      };

    case 'SUBMIT_AUTOSHIP_ORDER':
      return {
        ...state,
        loadingAutoShipOrder: false,
        autoShipPopUp: true,
        autoShipMessage: 'Your order has been submitted',
      };
    case 'ERROR_SUBMITTING_AUTOSHIP_ORDER':
      return {
        ...state,
        autoShipError: action.err.message,
        autoShipErrorPopup: true,
      };

    case 'ADD_ANOTHER_ITEM_TO_MONTH':
      //We will need to find the item in the charts items
      //let anotherOrder = state.order;

      if (action.resp.month !== 'bonus') {
        //console.log('This is my order', anotherOrder);
        if (action.resp.brand === 'Clear + Brilliant') {
          let anotherCBOrder = state.cbMonthItems;
          anotherCBOrder.months[action.resp.month].amount = state.cbMonthItems.months[action.resp.month].amount + 1;
          return {
            ...state,
            cbMonthItems: { months: [...anotherCBOrder.months], bonus: [...anotherCBOrder.bonus] },
          };
        } else if (action.resp.brand === 'Thermage') {
          let anotherTOrder = state.tMonthItems;
          anotherTOrder.months[action.resp.month].amount = state.tMonthItems.months[action.resp.month].amount + 1;
          return {
            ...state,
            tMonthItems: { months: [...anotherTOrder.months], bonus: [...anotherTOrder.bonus] },
          };
        } else if (action.resp.brand === 'Fraxel') {
          let anotherFOrder = state.fMonthItems;
          anotherFOrder.months[action.resp.month].amount = state.fMonthItems.months[action.resp.month].amount + 1;
          return {
            ...state,
            fMonthItems: { months: [...anotherFOrder.months], bonus: [...anotherFOrder.bonus] },
          };
        } else if (action.resp.brand === 'Bonus') {
          let anotherBOrder = state.bItemsMonth;
          anotherBOrder.months[action.resp.month].amount = state.bItemsMonth.months[action.resp.month].amount + 1;
          return {
            ...state,
            bItemsMonth: { months: [...anotherBOrder.months] },
          };
        } else {
          return {
            ...state,
          };
        }
      } else {
        if (action.resp.brand === 'Clear + Brilliant') {
          let anotherCBOrder = state.cbMonthItems;
          anotherCBOrder.bonus[0].amount = state.cbMonthItems.bonus[0].amount + 1;
          return {
            ...state,
            cbMonthItems: { months: [...anotherCBOrder.months], bonus: [...anotherCBOrder.bonus] },
          };
        } else if (action.resp.brand === 'Thermage') {
          let anotherTOrder = state.tMonthItems;
          anotherTOrder.bonus[0].amount = state.tMonthItems.bonus[0].amount + 1;
          return {
            ...state,
            tMonthItems: { months: [...anotherTOrder.months], bonus: [...anotherTOrder.bonus] },
          };
        } else if (action.resp.brand === 'Fraxel') {
          let anotherFOrder = state.fMonthItems;
          anotherFOrder.bonus[0].amount = state.fMonthItems.bonus[0].amount + 1;
          return {
            ...state,
            fMonthItems: { months: [...anotherFOrder.months], bonus: [...anotherFOrder.bonus] },
          };
        } else {
          return {
            ...state,
          };
        }
      }

    case 'ERROR_COPYING_ORDER':
      return {
        ...state,
        autoShipError: action.err.message,
        autoShipErrorPopup: true,
      };

    case 'ERROR_COPYING_AUTOSHIP_ORDER':
      return {
        ...state,
        autoShipError: action.err.message,
        autoShipErrorPopup: true,
      };

    case 'ERROR_COPYNO_AUTOSHIP_ORDER_FOUNDING_AUTOSHIP_ORDER':
      return {
        ...state,
        autoShipError: 'No autoship order found to copy',
        autoShipErrorPopup: true,
      };
    case 'AUTOSHIP_ON_CHANGE':
      return {
        ...state,
        [action.event.target.name]: action.event.target.value,
      };
    case 'ERROR_DELETING_AUTOSHIP_ORDER':
      return {
        ...state,
        autoShipError: action.err.message,
        autoShipErrorPopup: true,
      };
    case 'AUTOSHIP_ORDER_WAS_DELETED':
      return {
        ...state,
        autoShipPopUp: true,
        autoShipMessage: 'Your order has been deleted',
      };
    case 'AUTOSHIP_CHANGE_SHIPPING_ID':
      //console.log('this is my shipping ID', state.autoShipCompany.data.shippingIDs[action.index]);
      return {
        ...state,
        selectedShippingID: action.index,
        orderShippingID: state.autoShipCompany.data.shippingIDs[action.index],
      };
    case 'CLEAR_AUTOSHIP_COMPANY':
      //console.log('this is my shipping ID', state.autoShipCompany.data.shippingIDs[action.index]);
      return {
        ...state,
        autoShipCompany: null,
      };
    default:
      return {
        ...state,
      };
  }
};

export default autoShipReducer;

const getItemPricing = ({ singleItem, allItems, autoShipTiers, autoShipCompany, programElevate }) => {
  let newItemPricing = [];
  //console.log('this is my autoshipCompany', autoShipCompany);
  let itemPricing = allItems.filter((item) => item.data.sku === singleItem);
  //console.log('this is my item price', itemPricing);
  if (autoShipCompany) {
    if (autoShipCompany.data.eliteProgram) {
      let newTier = autoShipTiers.filter((t) => t.data.tierName === 'Diamond');
      newItemPricing.push(itemPricing.length > 0 ? itemPricing[0].data[newTier[0].id] : 0);
    } else {
      //We will also have to check for the elvation if so

      if (autoShipCompany.pureTier.tierName !== autoShipCompany.naturalTier.tierName) {
        newItemPricing.push(itemPricing.length > 0 ? itemPricing[0].data[autoShipCompany.pureTier.id] : 0);
        console.log('this is my item pricing ----> ', newItemPricing);
      } else {
        if (programElevate) {
          //We will need to find the id for the elevated tier
          if (autoShipCompany.pureTier.tierElevate === 'Diamond Elite' || autoShipCompany.pureTier.tierElevate === 'Diamond Ultra') {
            let newTier = autoShipTiers.filter((t) => t.data.tierName === 'Diamond');
            newItemPricing.push(itemPricing.length > 0 ? itemPricing[0].data[newTier[0].id] : 0);
          } else {
            let newTier = autoShipTiers.filter((t) => t.data.tierName === autoShipCompany.pureTier.tierElevate);
            newItemPricing.push(itemPricing.length > 0 ? itemPricing[0].data[newTier[0].id] : 0);
          }
        } else {
          //Use the pure tier for pricing

          if (autoShipCompany.pureTier.tierName === 'Diamond Elite' || autoShipCompany.pureTier.tierName === 'Diamond Ultra') {
            let newTier = autoShipTiers.filter((t) => t.data.tierName === 'Diamond');
            newItemPricing.push(itemPricing.length > 0 ? itemPricing[0].data[newTier[0].id] : 0);
          } else {
            console.log('this is my items pricing ---? ', itemPricing.length > 0 ? itemPricing[0].data[autoShipCompany.pureTier.id] : 0);
            if (autoShipCompany.pureTier.tierName === 'Bronze') {
              let newTier = autoShipTiers.filter((t) => t.data.tierName === 'Silver');
              newItemPricing.push(itemPricing.length > 0 ? itemPricing[0].data[newTier[0].id] : 0);
            } else {
              newItemPricing.push(itemPricing.length > 0 ? itemPricing[0].data[autoShipCompany.pureTier.id] : 0);
            }
          }
        }
      }
    }
  } else {
    //Find what the list tier id is
    let newTier = autoShipTiers.filter((t) => t.data.tierName === 'List');
    newItemPricing.push(itemPricing.length > 0 ? itemPricing[0].data[newTier[0].id] : 0);
  }

  return newItemPricing[0];
};

//This will figure out how many items are in groups.
const getTotalNumberofItems = ({ orderGroup }) => {
  let orderNumber = [];
  Object.keys(orderGroup).map((order) => {
    return orderNumber.push(orderGroup[order].quantiy);
  });

  return orderNumber.reduce((a, b) => a + b);
};

const getTotalNumberofSpend = ({ orderGroup }) => {
  let orderNumber = [];
  Object.keys(orderGroup).map((order) => {
    return orderNumber.push(orderGroup[order].price);
  });

  return orderNumber.reduce((a, b) => a + b);
};

const getMonthTotal = ({ orderGroup }) => {
  let orderNumber = [];
  //console.log('this is my orderGroup', orderGroup);
  //I am going to have to go through each group

  Object.keys(orderGroup['Clear + Brilliant']).map((order) => {
    return orderNumber.push(orderGroup['Clear + Brilliant'][order].price);
  });

  Object.keys(orderGroup['Fraxel']).map((order) => {
    return orderNumber.push(orderGroup['Fraxel'][order].price);
  });

  Object.keys(orderGroup['Thermage']).map((order) => {
    return orderNumber.push(orderGroup['Thermage'][order].price);
  });

  if (orderNumber.length > 0) {
    return orderNumber.reduce((a, b) => a + b);
  } else {
    return 0;
  }
};

const totalAmount = ({ orderGroup, multipleIDs }) => {
  let totalValue = [];
  Object.keys(orderGroup).map((order) => {
    if (multipleIDs) {
      Object.keys(orderGroup[order]).map((o) => {
        return totalValue.push(orderGroup[order][o].total);
      });
    } else {
      return totalValue.push(orderGroup[order].total);
    }
    return true;
  });

  return totalValue.reduce((a, b) => a + b);
};
